// extracted by mini-css-extract-plugin
module.exports = {"container":"MagicEcosystemControls_container__I6tsn","button":"MagicEcosystemControls_button__u4_Sq"};